module.exports = __webpack_public_path__ + "img/bodycare.a780345b.webp";